import button from './components/button';
import headerImage from './components/headerImage';
import leaderboardRewards from './components/leaderboardRewards';
import footer from './components/footer';
import style from './components/style';
import tinycolor from 'tinycolor2';

module.exports = {
  text: 'Week Left to Win',
  value: 'week-left-to-win',
  usersContext: 'LEADERBOARDS',
  subject: 'Week Left to Win',
  mjml(params) {
    const { brandingSettings: branding, leaderboard } = params;
    const slots = params.slots.map(({ content }) => ({
      content: content
        .replace(/{{[\s]*company\.name[\s]*}}/g, '{{defaults company.branding.name company.name "Referrals"}}'),
    }));

    const { prizes } = leaderboard;

    return `<mjml>
      <mj-head>
        <mj-title>${params.subject}</mj-title>
        <mj-include path="../include/styles.mjml"/>
        <mj-attributes>
          <mj-class name="content" background-color="${branding.backgroundColour || '#ffffff'}" border-radius="4px"/>
        </mj-attributes>
        <mj-style>
          ${style(branding)}
        </mj-style>
      </mj-head>

      <mj-body
        width="760px"
        background-color="${branding.backgroundColour || '#ffffff'}"
      >

        ${!branding.hideBrandLogo ? `<mj-section>
          <mj-column>
            <mj-include path="../include/branding-logo.mjml"/>
          </mj-column>
        </mj-section> ` : ''}

        ${branding.headerImage ? headerImage(branding.headerImage) : ''}

        <mj-section mj-class="content">
          <mj-column>
            <mj-text color="${branding.secondaryColour || '#333333'}">
              <div class="text-content">${slots[0].content}</div>
            </mj-text>
          </mj-column>
        </mj-section>

        <mj-section
          padding="44px 16px 12px 16px"
          background-color="${tinycolor(branding.primaryColour || '#dddddd').lighten(46).toString()}"
        >
          <mj-column>
            <mj-text
              font-size="26px"
              line-height="36px"
              align="center"
              font-family="${branding.headerFont || 'Arial'}"
              color="${branding.secondaryColour || '#333333'}"
            >
              <b>${slots[1].content}</b>
            </mj-text>
          </mj-column>
        </mj-section>

        <mj-section background-color="${tinycolor(branding.primaryColour || '#dddddd').lighten(46).toString()}"
          padding="44px 16px 0px 16px">${leaderboardRewards(prizes)}</mj-section>

        <mj-section
          background-color="${tinycolor(branding.primaryColour || '#dddddd').lighten(46).toString()}"
          padding="22px 16px 22px 16px"
        >
          ${slots[2] && slots[2].content ? `<mj-column>${button(slots[2].content, branding)}</mj-column>` : ''}
        </mj-section>

        ${footer(branding)}

        <mj-include path="../include/footer-disclaimer.mjml"/>
      </mj-body>
    </mjml>`;
  },
  slots: [
    {
      name: 'Main Content',
      type: 'html',
      defaultContent: `
        <h1>1 week left to win</h1>
        <p>This month's Real Links leaderboard ends next [Thursday]. It's not too late to get involved.
        Check out your competition below and start introducing connections and sharing company content to be in
        with a chance of winning.</p>
      `,
    },
    {
      name: 'Rewards Title',
      type: 'input',
      defaultContent: 'Rewards available...',
    },
    {
      name: 'Button Text',
      type: 'input',
      defaultContent: 'Hurry Login',
    },
  ],
};



// WEBPACK FOOTER //
// ./src/emails/week-left-to-win.js